import { useEffect, useState } from "react";

/** Executa `fn` sempre que `deps` mudam; controla loading/erro. */
export function useAsync(fn, deps) {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: null
  });

  useEffect(() => {
    let vivo = true;
    setState(s => ({ ...s, loading: true, error: null }));
    fn()
      .then(data => vivo && setState({ data, loading: false, error: null }))
      .catch(
        e =>
          vivo &&
          setState({
            data: null,
            loading: false,
            error: String(e?.message ?? e)
          })
      );
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return state;
}
